import { render, staticRenderFns } from "./liveradio.vue?vue&type=template&id=aa00f11c&"
import script from "./liveradio.vue?vue&type=script&lang=js&"
export * from "./liveradio.vue?vue&type=script&lang=js&"
import style0 from "./liveradio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports